import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { usePermissions } from "../../context/PermissionsProvider";
import { CircularProgress, Box } from "@mui/material";

const ProtectedRoute = ({ requiredPermission }) => {
  const { auth, loading } = useAuth();
  const permissions = usePermissions();
  const location = useLocation();

  if (loading) {
    return (
      <Box 
        sx={{ 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center", 
          height: "100vh" 
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!auth?.accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Mientras cargan permisos
  if (permissions === null) return null; 

  // Verifica el permiso requerido
  if (requiredPermission) {
    const { model, action } = requiredPermission;
    const hasPermission = permissions[model]?.[action] === true;
    if (!hasPermission) return <Navigate to="/access-denied" replace />;
  }

  //  renderiza ruta
  return <Outlet />;
};

export default ProtectedRoute;
